import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TileParametersModule } from 'src/app/pages/tiles/containers/tile-parameters/tile-parameters.module';
import { TileDirectivesModule } from 'src/app/pages/tiles/views/shared/directives/tile-directives.module';
import { TileViewModule } from 'src/app/pages/tiles/views/shared/tile-view/tile-view.module';
import { ChartWrapperModule } from '../chart-wrapper.module';
import { GraphTileComponent } from './graph-tile.component';

@NgModule({
   declarations: [GraphTileComponent],
   imports: [CommonModule, TileViewModule, TileParametersModule, TileDirectivesModule, ChartWrapperModule],
   exports: [GraphTileComponent],
})
export class GraphTileModule {}
